<template>
    <div class>
        <!-- 入口文件 头部和底部 -->
        <div class="topbar-container">
            <div class="container topbar-text">
                <span class="hello">{{basicinfoData.topBarText}}</span>
                <span style="display: flex;">
                    <span class="emali float-right mr-4 d-none d-md-block">{{basicinfoData.email}}</span>
                    <span class="phone mr-4 d-none d-md-block">{{basicinfoData.phone}}</span>
                    <span class="emali">
                        <a class="language-text" :class="currentLanguage == 'CN' ? 'lg-textclick' : ''" @click="changeLanguage('CN')">🇨🇳中文</a> /
                        <a class="language-text" :class="currentLanguage == 'EN' ? 'lg-textclick' : ''" @click="changeLanguage('EN')">🇬🇧EN</a> /
                        <a class="language-text" :class="currentLanguage == 'JP' ? 'lg-textclick' : ''" @click="changeLanguage('JP')">🇯🇵日本語</a>
                    </span>
                </span>
            </div>
        </div>
        <header class="header-container">
            <div class="container">
                <div class="row">
                    <div class="header-logo-container col-8 col-md-5 col-lg-4">
                        <a href="/" class="header-logo">
                            <img v-if="currentLanguage == 'CN'" src="../assets/image/logo_CN.png" alt="中山市光维光电科技有限公司" srcset />
                            <img v-else-if="currentLanguage == 'EN'" src="../assets/image/logo_EN.png" alt="中山市光维光电科技有限公司" srcset />
                            <img v-else-if="currentLanguage == 'JP'" src="../assets/image/logo_JP.png" alt="中山市光维光电科技有限公司" srcset />
                        </a>
                    </div>
                    <div class="header-btn-container col-4 d-md-none">
                        <a @click="navToggle" class="btn-toggle" id="btn-toggle">
                            <span class="btn-toggle-bar"></span>
                            <span class="btn-toggle-bar"></span>
                            <span class="btn-toggle-bar"></span>
                        </a>
                    </div>
                    <div class="header-nav-container col-6 col-md-7 col-lg-6 d-none d-md-block offset-lg-2">
                        <ul class="header-nav">
                            <li class="header-nav-item" v-for="(headerNav, index) in headerNavData" :key="index"
                                :class='headerNavActive===index?"header-nav-link-active":"" ' @click="navChange(index)">
                                <router-link tag="a" class="header-nav-link" :to='headerNav.link'>
                                    <p class="header-nav-title">{{headerNav.title}}</p>
                                    <p class="header-nav-subtitle">{{headerNav.subtitle}}</p>
                                </router-link>
                            </li>
                           <!-- <li class="header-nav-item">
                                <a href="http://455615p3f8.qicp.vip/" class="header-nav-link">
                                    <p class="header-nav-title">资料下载</p>
                                    <p class="header-nav-subtitle">Download</p>
                                </a>
                            </li> -->
                            <li class="header-nav-item" @click="clickSearch()"
                                :class='headerNavActive===5?"header-nav-link-active":"" '>
                                <router-link tag="a" class="header-nav-link icon-sousuo iconfont icon-sousuo"
                                    to='/search'></router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
        <nav class="nav-container d-md-none" :class="{changenav: changeNav}" id="nav">
            <ul class="container">
                <li v-for="(headerNav, index) in headerNavData" :key="index">
                    <router-link tag="a" class="nav-link" :to='headerNav.link'>{{headerNav.title}}</router-link>
                </li>
                <!-- <li>
                    <a class="nav-link" href="http://455615p3f8.qicp.vip/">资料下载</a>
                </li> -->
                <li>
                    <router-link tag="a" class="nav-link icon-sousuo iconfont icon-sousuo" to='/search'></router-link>
                </li>
            </ul>
        </nav>
        <router-view :key="$route.path"></router-view>

        <footer class="footer-container">
            <div class="container">
                <div class="row footer-info-nav">
                    <div class="col-12 col-md-6 footer-info">
                        <div>
                            <div class="footer-info-logo col-9 col-md-12 clearPadding">
                                <img v-if="currentLanguage == 'CN'" src="../assets/image/footer_logo_CN.png" alt />
                                <img v-else-if="currentLanguage == 'EN'" src="../assets/image/logo_EN.png" alt />
                                <img v-else-if="currentLanguage == 'JP'" src="../assets/image/footer_logo_JP.png" alt />
                            </div>
                            <p class="footer-info-email">{{basicinfoData.email}}</p>
                            <p class="footer-info-phone">{{basicinfoData.phone}}</p>
                            <p class="footer-info-add">{{basicinfoData.address}}</p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 footer-nav">
                        <div class="" style="flex: 1;">
                            <h3 v-if="currentLanguage == 'CN'" class="footer-nav-list-title">网站导航</h3>
                            <h3 v-else-if="currentLanguage == 'EN'" class="footer-nav-list-title">Navigation</h3>
                            <h3 v-else-if="currentLanguage == 'JP'" class="footer-nav-list-title">ナビゲーション</h3>
                            <ul>
                                <li v-for=" (navData, index) in headerNavData" :key="index">
                                    <router-link tag="a" class="footer-nav-list-link" :to='navData.link'>
                                        {{navData.title}}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="footer-nav-item" v-for="(item, index) in productsData.slice(0,2)" :key="index">
                            <h3 class="footer-nav-list-title">{{item.name}}</h3>
                            <ul>
                                <li v-for=" (productsList, index) in item.productsList.slice(0,5)" :key="index">
                                    <router-link tag="a" :to="`/productscontent/${productsList._id}`"
                                        class="footer-nav-list-link" href="#">{{productsList.name}}</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="footer-copyright">
                    <span>{{basicinfoData.copyright}}</span>
                    <span>
                        <a style="color:#999;font-size: 12px;" target="_blank" href="https://beian.miit.gov.cn">{{basicinfoData.icp}}</a>
                    </span>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    import baseDataCN from '../data/CN/basicinfoData_CN.json'
    import baseDataEN from '../data/EN/basicinfoData_EN.json'
    import baseDataJP from '../data/JP/basicinfoData_JP.json'
    import productslistCN from '../data/CN/productslist_CN.json'
    import productslistEN from '../data/EN/productslist_EN.json'
    import productslistJP from '../data/JP/productslist_JP.json'
    import navCN from '../data/CN/nav_CN.json'
    import navEN from '../data/EN/nav_EN.json'
    import navJP from '../data/JP/nav_JP.json'

    export default {
        data() {
            return {
                changeNav: false,
                headerNavActive: 0,
                basicinfoData: {},
                currentLanguage: '', // 当前语言
                headerNavData: [],
                productsData: [],
            }
        },
        mounted() {
            const _this = this
            window.addEventListener('setItemEvent', function(e) {
                // e.key : 是值发生变化的key
                // 例如 e.key==="token";
                // e.newValue : 是可以对应的新值
                if (e.key === 'language') {
                    var d = e.newValue
                    if (d === 'CN') {
                        _this.basicinfoData = baseDataCN
                        _this.headerNavData = navCN
                        _this.productsData = productslistCN
                    } else if (d === 'EN') {
                        _this.basicinfoData = baseDataEN
                        _this.headerNavData = navEN
                        _this.productsData = productslistEN
                    } else if (d === 'JP') {
                        _this.basicinfoData = baseDataJP
                        _this.headerNavData = navJP
                        _this.productsData = productslistJP
                    }
                }
            })
        },
        methods: {
            navToggle: function() {
                this.changeNav = !this.changeNav
            },
            navChange: function(index) {
                this.headerNavActive = index
            },
            clickSearch: function() {
                this.headerNavActive = 5
            },
            changeLanguage(e) {
                this.currentLanguage = e
                localStorage.setItem('language', e)
            },
            // 查询所有的基本信息
            findBasicinfo: function() {
                var lg = localStorage.getItem('language')
                this.currentLanguage = lg
                if (lg === 'CN') {
                    this.basicinfoData = baseDataCN
                    this.headerNavData = navCN
                    this.productsData = productslistCN
                    this.logoData = '../assets/image/logo_CN.png'
                } else if (lg === 'EN') {
                    this.basicinfoData = baseDataEN
                    this.headerNavData = navEN
                    this.productsData = productslistEN
                    this.logoData = '../assets/image/logo_EN.png'
                } else if (lg === 'JP') {
                    this.basicinfoData = baseDataJP
                    this.headerNavData = navJP
                    this.productsData = productslistJP
                    this.logoData = '../assets/image/logo_JP.png'
                }
            }
        },
        created() {
            if (localStorage.getItem('language') == null) {
                localStorage.setItem('language', 'EN')
            }
            this.findBasicinfo()
        }
    }
</script>

<style scoped>
    @import "../assets/css/Main.css";
</style>
